import { Link } from '@mui/material';

import { LabelChipV2, Stack } from '@cast/design-system';

import { Link as RouterLink } from 'components/router';

type TemplateWithVersionProps = {
  name: string;
  version: string;
  path: string;
  testId?: string;
  withVersionPrefix?: boolean;
};

export const TemplateLinkWithVersion = ({
  name,
  version,
  path,
  testId,
  withVersionPrefix = false,
}: TemplateWithVersionProps) => {
  return (
    <Stack direction="row" gap="8px" alignItems="center">
      <Link
        data-testid={testId}
        component={RouterLink}
        underline="none"
        fontWeight="medium"
        to={path}
      >
        {name}
      </Link>
      <LabelChipV2
        color="blue"
        label={withVersionPrefix ? `V${version}` : version}
      />
    </Stack>
  );
};
